import { render, staticRenderFns } from "./OrganizationList.vue?vue&type=template&id=0477e36c&scoped=true"
import script from "./OrganizationList.vue?vue&type=script&lang=ts"
export * from "./OrganizationList.vue?vue&type=script&lang=ts"
import style0 from "./OrganizationList.vue?vue&type=style&index=0&id=0477e36c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0477e36c",
  null
  
)

export default component.exports